module.exports = __webpack_public_path__ + "static/img/personalinformation.8781d5ec.png";